import { render, staticRenderFns } from "./DatabaseSupplierEmailView.vue?vue&type=template&id=5ec5e280"
import script from "./DatabaseSupplierEmailView.vue?vue&type=script&lang=js"
export * from "./DatabaseSupplierEmailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports